import React       from 'react';
import HiddenInput from './HiddenInput';

const SupplierSelected = ({ parameters, groupName }) => {
  const name = 'supplier_selected';
  return (
    <HiddenInput
      name={name}
      value={parameters[name]}
      groupName={groupName} />
  );
};

SupplierSelected.defaultProps = {
};

export default SupplierSelected;
